import * as actionTypes from './action-types';
import * as legacyActionTypes from './legacy/action-types';
import Immutable from 'immutable';

export const atlasInitialState = Immutable.fromJS({
  atlasDockerSoftwareInfo: Immutable.Map(),
  atlasInstallerSoftwareInfo: Immutable.Map(),
  atlasServerSoftwareInfo: Immutable.Map(),
  atlasKubernetesSoftwareInfo: Immutable.Map(),
  atlasv1Data: Immutable.List(),
  isLoading: true,
  licenseKey: 'Loading...',
  user: Immutable.Map()
});

function atlasReducer(state = atlasInitialState, action) {
  switch (action.type) {
    case legacyActionTypes.ATLAS_V1_SOFTWARE_INFO_LOAD:
      return state
        .set('atlasv1Info', Immutable.fromJS(action.info))
        .set('isLoading', false);
    case legacyActionTypes.ATLAS_V1_SOFTWARE_NOT_AUTHORIZED:
      return state
        .set('atlasV1NotAuthorized', action.info)
        .set('isLoading', false);
    case legacyActionTypes.ATLAS_V1_DATA_LOAD:
      return state.set('atlasv1Data', Immutable.fromJS(action.info));
    case legacyActionTypes.SET_IS_DONE_LOADING_INSTALLER:
      return state.set('isLoading', false);

    case actionTypes.RECEIVED_ATLAS_INSTALLER_VERSIONS:
      return state.set(
        'atlasInstallerSoftwareInfo',
        Immutable.fromJS(action.info)
      );
    case actionTypes.RECEIVED_ATLAS_DOCKER_VERSIONS:
      return state.set(
        'atlasDockerSoftwareInfo',
        Immutable.fromJS(action.info)
      );
    case actionTypes.RECEIVED_KUBERNETES_VERSIONS:
      return state.set(
        'atlasKubernetesSoftwareInfo',
        Immutable.fromJS(action.info)
      );
    case actionTypes.RECEIVED_LICENSE_KEY:
      return state.set('licenseKey', action.info);
    case actionTypes.FAILED_TO_FETCH_LICENSE_KEY:
      return state.set('licenseKey', "Couldn't fetch your license key");
    case actionTypes.USER_LOADED:
      return state.set('user', action.info);
    default: {
      return state;
    }
  }
}

export { atlasReducer };
